module.exports = __webpack_public_path__ + "img/box6.ced98232.png";